import { gql } from '@apollo/client';

export const LapFragment = gql`
    fragment Lap on Lap {
        id
        name
        from
        to
        platform
        isCurrent
        course {
            id
            name
            testAvailable
        }
        platoons {
            id
            company
            platoon
            platoonX
        }
        programType
        companyCount
        platoonCount
        programType
        financialType
        isFree
        canCertificate
        canStudentEarlyAccess
        canStudentViewOLTestResult
        studentViewOLTestResultAfterSuccess
    }
`;
